export default __webpack_public_path__ + "static/media/meBingo.ebae82e0.jpg";